import { initContract } from '@ts-rest/core';
import { adminPromoContract } from './promo.admin.contract';
import { authPromoContract } from './promo.auth.contract';
import { publicPromoContract } from './promo.public.contract';

const c = initContract();

export const promoContract = c.router(
  {
    admin: adminPromoContract,
    public: publicPromoContract,
    auth: authPromoContract,
  },
  {
    pathPrefix: '/promo',
    strictStatusCodes: true,
    jsonQuery: true,
  }
);

export * from './models';
export * from './promo.admin.contract';
export * from './promo.auth.contract';
export * from './promo.public.contract';

